import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatNativeDateModule, DateAdapter } from '@angular/material/core';
import { MatInputModule} from '@angular/material';
import { BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CandidateApplicationFormComponent } from './common/candidate-application-form/candidate-application-form.component';
import { CandidateApplicationForm1Component } from './common/candidate-application-form1/candidate-application-form1.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { HttpClientModule, HttpClientJsonpModule, HttpClient } from '@angular/common/http';
import { SuccessComponent } from './common/success/success.component';
import { TermsAndConditionsFirstFormComponent } from './common/terms-and-conditions-first-form/terms-and-conditions-first-form.component';
import { TermsAndConditionsSecondFormComponent } from './common/terms-and-conditions-second-form/terms-and-conditions-second-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FailedComponent } from './common/failed/failed.component';
import { NgHttpLoaderModule } from 'ng-http-loader';
import {MatRadioModule} from '@angular/material/radio';
import { TranslateModule, TranslateLoader  } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { JobDetailsComponent } from './common/job-details/job-details.component';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material';
import { JobsComponent } from './common/jobs/jobs.component';
import { WINDOW_PROVIDERS } from './window.providers';
import { SampleService } from './service';
import { JobHeaderComponent } from './common/job-header/job-header.component';
import { Error404Component } from './common/error404/error404.component';
import { FooterComponent } from './common/footer/footer.component';
import { UpdateComponent } from './common/update/update.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CandidateApplicationFormComponent,
    CandidateApplicationForm1Component,
    SuccessComponent,
    TermsAndConditionsFirstFormComponent,
    TermsAndConditionsSecondFormComponent,
    FailedComponent,
    JobDetailsComponent,
    JobsComponent,
    JobHeaderComponent,
    Error404Component,
    FooterComponent,
    UpdateComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatSelectModule,
    HttpClientModule,
    HttpClientJsonpModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule.withConfig({warnOnNgModelWithFormControl: 'never'}),
    NgHttpLoaderModule.forRoot(),
    MatRadioModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    MatProgressSpinnerModule
  ],
  exports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    TranslateModule,
  ],
  providers: [
    WINDOW_PROVIDERS,
    SampleService,
    Title
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    MatSpinner
  ]
})
export class AppModule {}
